/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Auth from "../../shared/Auth";
import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import Alert from "../Alert";
import BaseCom from "../BaseCom";
import Card from "../Card";
import FormInput from "../FormInput";
import Tick from "../Tick";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class ScanInventory extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {},
            scan: {},
            scanHistory: []
        };
    }

    async componentDidMount() {
        await this.fillListAsync('/api/account/list', 'accounts');
    }

    change = (e, resetPO) => {
        let info = { ...this.state.info };
        if (resetPO)
            info.purchaseOrderID = null;
        this.setState({ info: info });
    }

    onAccountChange = async (v) => {
        if (!Auth.hasRole('manager'))
            return;
        if (!v)
            return;
        try {
            let j = await qreq.getAsync('/api/purchase-order/list/out/' + v);
            if (j.list)
                this.setState({ purchaseOrders: j.list });
            else
                this.alert(j.errorMessage);
            this.change(null, true);
        }
        catch (e) {
            this.unkownErrorCallback(e);
            this.change(null, true);
        }
    }

    scan = async (v) => {
        this.setState({ scannedItem: null, errorMessage: null });
        if (!v || v.length < 2)
            return;
        try {
            let j = await qreq.postAsync('/api/inventory/scan', {
                accountID: Number(this.state.info.accountID),
                lotNumber: v,
                in: this.props.in,
                out: this.props.out,
                purchaseOrderID: this.state.info.purchaseOrderID
            });
            if (j.item) {
                let scanHistory = [...this.state.scanHistory];
                j.item.scanDate = new Date();
                scanHistory.unshift(j.item);
                this.setState({ scan: {}, scannedItem: j.item, scanHistory: scanHistory });
            }
            else {
                this.setState({ errorMessage: j.errorMessage });
            }
        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    checkScan = async () => {
        if (this.state.scan?.barcode !== this.currentScan) {
            this.currentScan = this.state.scan?.barcode;
            await this.scan(this.state.scan.barcode);
        }
    }

    render() {
        return (
            <div className="container-fluid">
                <h1>Scan Inventory</h1>
                <Card title={this.props.in ? 'Scan In' : 'Scan Out'}>
                    {(this.props.out || !Auth.hasRole('manager'))
                        && <><FormInput model={this.state.info}
                            label="Account"
                            name="accountID"
                            type="select"
                            options={this.state.accounts ?? []}
                            onChange={this.onAccountChange}
                            autoSelect
                        />
                            {Auth.hasRole('manager') && <FormInput model={this.state.info}
                                label="Purchase Order"
                                name="purchaseOrderID"
                                type="select"
                                options={this.state.purchaseOrders ?? []}
                                onChange={this.change}
                            />}
                        </>}
                    <FormInput
                        model={this.state.scan}
                        label="Barcode"
                        name="barcode"
                        disabled={this.props.out
                            && (!this.state.info.accountID || !this.state.info.purchaseOrderID)}
                    />
                </Card>
                <Tick onTick={this.checkScan} />
                {this.state.errorMessage && <Alert type="danger" message={this.state.errorMessage} />}
                {this.state.scanHistory?.length > 0 && <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>Manufacturer</th>
                            <th>Product</th>
                            <th>Size</th>
                            <th>Catalog Code</th>
                            <th>Lot Number</th>
                            <th>Expiration Date</th>
                            <th>Scan Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.scanHistory.map((item, idx) => <tr key={idx}>
                            <td>{item.manufacturerName}</td>
                            <td>{item.productName}</td>
                            <td>{item.productSize}</td>
                            <td>{item.catalogCode}</td>
                            <td>{item.lotNumber}</td>
                            <td>{item.expirationDate}</td>
                            <td>{Globals.toMDYHMLocalDateStringOrDiff(item.scanDate)}</td>
                        </tr>)}
                    </tbody>
                </table>}

            </div>
        );
    }
}

export default withParamsAndNavigate(ScanInventory);